export default __webpack_public_path__ + "static/media/Orc.15861545.mp4";